import React from 'react'
import classNames from 'classnames'
import { ContainedNavItemProps } from '../'
import { NavLink } from 'react-router-dom'
import styles from '../styles.css'

const NavItem: React.FC<ContainedNavItemProps> = ({
  to,
  isActive,
  testId,
  menuOptions,
  menuPosition,
  onNavItemMouseEnter,
  onNavItemMouseLeave,
  isNavItemHovered,
  onStaticAction,
  children,
  ...rest
}) => {
  const navItemHasMenu = !!menuOptions

  return (
    <li
      className={styles.navItem}
      onClick={() => {
        onStaticAction && onStaticAction()
      }}
      onMouseEnter={() => onNavItemMouseEnter(navItemHasMenu)}
      onMouseLeave={() => onNavItemMouseLeave()}
      data-testid={testId ? `${testId}-menu-trigger` : ''}
    >
      {to ? (
        <NavLink
          to={to}
          className={classNames(styles.navItemLink, {
            [styles.navItemLinkHovered]: isNavItemHovered
          })}
          activeClassName={styles.navItemLinkActive}
          isActive={isActive}
          {...rest}
        >
          <div className={styles.navItemHighlight}>{children}</div>
        </NavLink>
      ) : (
        <span
          className={classNames(styles.navItemLink, {
            [styles.navItemLinkHovered]: isNavItemHovered
          })}
        >
          <div className={styles.navItemHighlight}>{children}</div>
        </span>
      )}
      {menuOptions && (
        <div
          className={classNames(styles.menuContent, {
            [styles.visible]: isNavItemHovered
          })}
        >
          <ul
            data-testid={testId ? `${testId}-menu` : ''}
            className={classNames(styles.menu, {
              [styles.menuLeft]: menuPosition === 'left',
              // Serve this as a default since we can't make this required
              [styles.menuRight]: menuPosition !== 'left'
            })}
          >
            {menuOptions}
          </ul>
        </div>
      )}
    </li>
  )
}

export default NavItem
